module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAALVBMVEUAAAD/1iEmJib/1yIoKCgmJiYmJib/1SAmJib/1iAiIiIlJSX/1SHwFRXhExPzSvAOAAAAC3RSTlMA8PEmJu6urq2tJsVEJpEAAABSSURBVDjLYxicgKVpNxagsYDBdTdWEMKQjV1iG4M2dolNDLtxgKEmcRcHGGoS73AAakqcwQGGmoQMdvGDDDXYJY4zGGKXEGZgnohNXNKAYVACAB3wrt/pyuI+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flag/de@2x.png
// module id = sGfM
// module chunks = 0